<template>
  <div class="szw-col szw-w-full szw-h-fit szw-px-1 szw-text-xs">
    <div class="szw-row szw-w-full szw-gap-2 szw-mb-1">
      <span class="szw-bg-section-static szw-h-3 szw-rounded szw-animate-pulse szw-w-9"></span>
      <span class="szw-bg-section-static szw-w-9 szw-h-3 szw-rounded szw-animate-pulse"></span>

      <span class="szw-bg-section-static szw-w-17 szw-h-3 szw-rounded szw-animate-pulse szw-mx-auto"></span>

      <span class="szw-bg-section-static szw-w-9 szw-h-3 szw-rounded szw-animate-pulse"></span>
      <span class="szw-bg-section-static szw-h-3 szw-rounded szw-animate-pulse szw-w-9"></span>
    </div>

    <div class="szw-flex szw-w-full szw-h-1">
      <div class="szw-h-full szw-w-1/2 szw-line-chart-left szw-bg-section-static szw-animate-pulse"></div>
      <div class="szw-h-full szw-w-1/2 szw-line-chart-right szw-bg-section-static szw-animate-pulse"></div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.szw-line-chart-left {
  transform: skew(-20deg, 0deg);
  position: relative;
  padding: 2px 20px 2px 10px;

  &:after {
    content: ' ';
    position: absolute;
    display: block;
    width: 3px;
    height: 100%;
    top: 0;
    left: calc(100% - 3px);
    z-index: 1;
    transform-origin: bottom left;
  }

  margin: 0 2px;
}

.szw-line-chart-right {
  transform: skew(-20deg, 0deg);
  position: relative;
  padding: 2px 20px 2px 10px;

  &:before {
    content: ' ';
    position: absolute;
    display: block;
    width: 3px;
    height: 100%;
    top: 0;
    left: -3px;
    z-index: 1;
    transform-origin: bottom right;
  }

  margin: 0 2px;
}
</style>
